import { udpApi } from 'yxt-biz-pc/packages/api';

export const getSpares = () => {
  return udpApi.post('orgs/spares/keylist/component', {
    orgId: window.localStorage.orgId,
    status: 1
  });
};
